<template>
    <el-form :model="checkItem" :rules="checkItemCheck" ref="checkItemInfo">
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">项目内容</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="content">
                        <el-input class="width-2x" v-model="checkItem.content"></el-input>
                        <span class="font-red">注:最大长度为60个字</span>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">基本要求</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="demand">
                        <el-input class="width-2x" v-model="checkItem.demand"></el-input>
                        <span class="font-red">注:最大长度为125个字</span>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>参考标准</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="standard">
                        <el-input class="width-2x" v-model="checkItem.standard"></el-input>
                        <span class="font-red">注:最大长度为30个字</span>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>适用分类</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="appliedCatNames">
                        <el-input class="width-2x" type="textarea" v-model="checkItem.appliedCatNames"></el-input>
                        <a class="swb-btn-link" @click="selectCatName()">快捷输入</a>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>需要拍照</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="snapshotRequired">
                        <el-checkbox v-model="checkItem.snapshotRequired"></el-checkbox>
                    </el-form-item>
                </div>
            </div>
        </div>
    </el-form>
</template>

<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox} from '../../app.vues'

    import devcMaintApi from '../../api/devcMaint'

    import {openCategTreeMultiSelectDlg} from'../categ/selectDlg'

    export default{
        name: 'swb-check-item-save',
        desc: '凭单检查项保存',
        props: ['id'],
        data: function () {
            let content = function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('项目内容不能为空'));
                } else if (value.length > 60) {
                    callback(new Error('项目内容最大长度为60个字'));
                } else {
                    callback();
                }
            };

            let demand = function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('基本要求不能为空'))
                } else if (value.length > 125) {
                    callback(new Error('基本要求最大长度为125个字'));
                } else {
                    callback();
                }
            };
            let standard = function (rule, value, callback) {
                if (!Utils.isNoB(value) && value.length > 30) {
                    callback(new Error('参考标准最大长度为30个字'));
                } else {
                    callback();
                }
            };
            let appliedCatNames = function (rule, value, callback) {
                if (!Utils.isNoB(value) && value.length > 250) {
                    callback(new Error('适用分类最大长度为250个字'));
                } else {
                    callback();
                }
            };
            return {
                checkItem: {
                    snapshotRequired: false
                },
                checkItemCheck: {
                    content: [{validator: content, trigger: 'blur'}],
                    demand: [{validator: demand, trigger: 'blur'}],
                    standard: [{validator: standard, trigger: 'blur'}],
                    appliedCatNames: [{validator: appliedCatNames, trigger: 'blur'}],
                }
            }

        },
        created: function () {
            let self = this;
            if (self.id != null) {
                let postData = {};
                postData.id = self.id;
                let loading = MsgBox.loading();
                devcMaintApi.getDevcMaintCheckItemById(postData, function (result) {
                    loading.close();
                    if (result.type === 'info') {
                        self.checkItem = result.data;
                    } else {
                        self.$message.error();
                    }
                });
            }
        },
        methods: {
            selectCatName: function () {
                let self = this;
                let dlgConfig = {
                    showCheckboxLevel1: true,
                    showCheckboxLevel2: true,
                    checkStrictly: true,
                    model: {
                        catIdColumn: 'catId',
                        catNameColumn: 'catName'
                    }
                };
                let checkItem = self.checkItem;
                let appliedCatNames = checkItem.appliedCatNames || '';
                openCategTreeMultiSelectDlg(dlgConfig, [], function (result) {
                    if (result.type == "info") {
                        let resultData = result.data;
                        //
                        let names = resultData.pluck("catName");
                        let catNameList = [];
                        if (!Utils.isNoB(appliedCatNames) && appliedCatNames != '') {
                            catNameList = appliedCatNames.split("、");
                        }
                        let appliedCatNameList = catNameList.concat(names);
                        appliedCatNames = appliedCatNameList.join("、");
                        checkItem.appliedCatNames = appliedCatNames;
                        self.checkItem = Utils.merge({}, checkItem);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                self.$refs['checkItemInfo'].validate(function (valid) {
                    if (valid) {
                        result.data = self.checkItem;
                        result.type = 'info';
                    } else {
                        result.type = 'warn';
                        result.message = "校验失败"
                    }
                });
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/devcMaint/DevcMaintCheckItemSave.vue